import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimgs from "../../../assets/cppProgrammingLeftImg.png";
import rightimgs from "../../../assets/cppProgrammingRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import cppProgrammingBenefitsImg1 from "../../../assets/cppProgrammingBenefitsImg1.png";
import cppProgrammingBenefitsImg2 from "../../../assets/cppProgrammingBenefitsImg2.png";
import cppProgrammingBenefitsImg3 from "../../../assets/cppProgrammingBenefitsImg3.png";
import cppProgrammingBenefitsImg4 from "../../../assets/cppProgrammingBenefitsImg4.png";
import cppProgrammingBenefitsImg5 from "../../../assets/cppProgrammingBenefitsImg5.png";
import cppProgrammingBenefitsImg6 from "../../../assets/cppProgrammingBenefitsImg6.png";
import cppProgrammingBenefitsImg7 from "../../../assets/cppProgrammingBenefitsImg7.png";
import cppProgrammingBenefitsImg8 from "../../../assets/cppProgrammingBenefitsImg8.png";
import cppProgrammingBenefitsImg9 from "../../../assets/cppProgrammingBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import cppProgrammingFunActivitiesImg1 from "../../../assets/cppProgrammingFunActivitiesImg1.png";
import cppProgrammingFunActivitiesImg2 from "../../../assets/cppProgrammingFunActivitiesImg2.png";
import cppProgrammingFunActivitiesImg3 from "../../../assets/cppProgrammingFunActivitiesImg3.png";
import cppProgrammingFunActivitiesImg4 from "../../../assets/cppProgrammingFunActivitiesImg4.png";
import cppProgrammingFunActivitiesImg5 from "../../../assets/cppProgrammingFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

const CppProgrammingPortal = () => {
  const cppProgrammingpage = heroContent.cppProgrammingpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "10",
      classes: "5",
      description:
        "Fundamentals of C++ Students will learn C++ basics, including variables, data types, conditions, and operators, building a strong foundation in the language.",
    },
    {
      title: "Module 2",
      activities: "10",
      classes: "5",
      description:
        "C++ Logics Students will explore loops, arrays, and functions, learning how to handle repetitive tasks, store large data, and create reusable code.",
    },
    {
      title: "Module 3",
      activities: "10",
      classes: "5",
      description:
        "Object-Oriented Programming- Students will learn about classes, objects, inheritance, polymorphism, encapsulation, and file handling to organize code and manage data effectively.",
    },
  ];

  const benefitsData = [
    {
      title: "Master Programming Basics",
      description: "Learn variables, data types, and operators in C++.",
      icon: "Polymath-images/cppProgrammingBenefitsImg1.png",
    },
    {
      title: "Enhance Problem-Solving",
      description: "Develop logical and creative thinking.",
      icon: "Polymath-images/cppProgrammingBenefitsImg2.png",
    },
    {
      title: "Create Object-Oriented Code",
      description: "Understand classes, objects, and inheritance.",
      icon: "Polymath-images/cppProgrammingBenefitsImg3.png",
    },
    {
      title: "Build Advanced Apps",
      description: "Work with functions, loops, and arrays.",
      icon: "Polymath-images/cppProgrammingBenefitsImg4.png",
    },
    {
      title: "Sharpen Math Skills",
      description: "Apply programming to solve mathematical problems.",
      icon: "Polymath-images/cppProgrammingBenefitsImg5.png",
    },
    {
      title: "Boost Creativity",
      description: "Express ideas through code and design.",
      icon: "Polymath-images/cppProgrammingBenefitsImg6.png",
    },
    {
      title: "Foster Persistence",
      description: "Overcome challenges with determination.",
      icon: "Polymath-images/cppProgrammingBenefitsImg7.png",
    },
    {
      title: "Advance Career Potential",
      description: "Unlock job opportunities in tech.",
      icon: "Polymath-images/cppProgrammingBenefitsImg8.png",
    },
    {
      title: "Develop Digital Literacy",
      description: "Gain essential tech skills for the future.",
      icon: "Polymath-images/cppProgrammingBenefitsImg9.png",
    },
  ];
  const activitiesData = [
    {
      title: "Bill Calculator",
      image: "Polymath-images/cppProgrammingFunActivitiesImg1.png",
    },
    {
      title: "Cricket Statistics",
      image: "Polymath-images/cppProgrammingFunActivitiesImg2.png",
    },
    {
      title: "Bank Transactions",
      image: "Polymath-images/cppProgrammingFunActivitiesImg3.png",
    },
    {
      title: "Grade Calculator",
      image: "Polymath-images/cppProgrammingFunActivitiesImg4.png",
    },
    {
      title: "File Handling",
      image: "Polymath-images/cppProgrammingFunActivitiesImg5.png",
    },
  ];

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
      leftImg={"Polymath-images/cppProgrammingLeftImg.png"}
      rightImg={"Polymath-images/cppProgrammingRightImg.png"}
      titlePart1="C++ Programming"
      titlePart2="Course"
      description="Polymath-kids offer comprehensive online C++ programming course, a text-based programming language.The online coding classes' offers two modes- online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From C++ Programming"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn C++ Programming"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default CppProgrammingPortal;
